import {Directive, OnInit, Output, EventEmitter} from '@angular/core';

@Directive({
    selector: '[ngAfterInit]'
})
export class NgAfterInitDirective implements OnInit {
   

    @Output()
    ngAfterInit: EventEmitter<any> = new EventEmitter();

    ngAfterViewInit(): void {
        this.ngAfterInit.emit();
    }
    ngOnInit() {
        
    }
}
